import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, MailIcon, MessageCircleIcon } from 'lucide-react';
import { EMAIL_SEQUENCE, WHATSAPP_SCRIPTS } from '../data/messages';
export function Seguimiento() {
  return <div className="min-h-screen w-full bg-steel-50" data-id="element-338" data-mp="17nzkkcf3mwk1">
      <main className="mx-auto max-w-3xl px-4 py-14 sm:px-6" data-id="element-339" data-mp="1clhlbfiyq5gy">
        <Link to="/" className="inline-flex items-center gap-2 text-sm font-medium text-navy-700 transition-colors duration-150 ease-out hover:text-accent-600" data-id="element-340" data-mp="1ckzpgk07pt9k">
          <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-341" data-mp="jxltop8933r1" />
          Volver a la landing
        </Link>

        <h1 className="mt-6 font-display text-4xl font-bold leading-tight text-navy-900" data-id="element-342" data-mp="ou3rt692s3ue">
          Seguimiento del prospecto (uso interno)
        </h1>
        <p className="mt-3 text-[15px] text-steel-600" data-id="element-343" data-mp="3sdoxgjw8s8a3">
          Secuencia de 5 emails automáticos para quien llena el formulario y no cierra, más los guiones de WhatsApp
          para el seguimiento manual.
        </p>

        <section className="mt-10" data-id="element-344" data-mp="2abvgq7s2kp54">
          <h2 className="flex items-center gap-2 font-display text-2xl font-semibold text-navy-900" data-id="element-345" data-mp="2af12pe5ejawm">
            <MailIcon className="h-5 w-5 text-accent-500" aria-hidden="true" data-id="element-346" data-mp="25gg4tldmh3bc" />
            Secuencia de email
          </h2>
          <ol className="mt-5 space-y-4" data-id="element-347" data-mp="1votwbwso5ica">
            {EMAIL_SEQUENCE.map(email => <li key={email.id} className="rounded-xl border border-steel-200 bg-white p-5" data-id="element-348" data-mp="1rmfdvdswwklj">
                <p className="text-xs font-semibold uppercase tracking-wide text-accent-600" data-id="element-349" data-mp="1mnvo12b76onw">{email.timing}</p>
                <h3 className="mt-2 font-display text-xl font-semibold text-navy-900" data-id="element-350" data-mp="1hnzigymuqp68">Asunto: {email.subject}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-steel-600" data-id="element-351" data-mp="1cq7ps2eduz0z">{email.body}</p>
                <p className="mt-3 inline-block rounded bg-steel-100 px-3 py-1.5 text-sm font-semibold text-navy-800" data-id="element-352" data-mp="3c2sfn23dvo0a">
                  CTA: {email.cta}
                </p>
              </li>)}
          </ol>
        </section>

        <section className="mt-12" data-id="element-353" data-mp="15cys9mkzrz48">
          <h2 className="flex items-center gap-2 font-display text-2xl font-semibold text-navy-900" data-id="element-354" data-mp="1a4qa98q30wir">
            <MessageCircleIcon className="h-5 w-5 text-accent-500" aria-hidden="true" data-id="element-355" data-mp="vgdp76sj8y31" />
            Guiones de WhatsApp
          </h2>
          <ul className="mt-5 space-y-4" data-id="element-356" data-mp="10g8b0vxgaxh8">
            {WHATSAPP_SCRIPTS.map(script => <li key={script.id} className="rounded-xl border border-steel-200 bg-white p-5" data-id="element-357" data-mp="1o5sy9r0n0gwb">
                <p className="text-xs font-semibold uppercase tracking-wide text-steel-600" data-id="element-358" data-mp="1t2t5445b9noh">{script.label}</p>
                <p className="mt-2 text-[15px] leading-relaxed text-navy-800" data-id="element-359" data-mp="1f3bav998xi7q">{script.text}</p>
              </li>)}
          </ul>
        </section>
      </main>
    </div>;
}